import { render } from "./pageHeader.vue?vue&type=template&id=7b72539e"
import script from "./pageHeader.vue?vue&type=script&lang=js"
export * from "./pageHeader.vue?vue&type=script&lang=js"

import "./pageHeader.vue?vue&type=style&index=0&id=7b72539e&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__